/**
 * Created by anatoly on 23.03.2025
 */

const OrderHintLogic = {
    type: "order",
    priority: 10,

    chooseConfig: function () {
        const location = cleverapps.meta.getSelectedLocation();
        const fix = location.getContinuousStage();

        if (fix >= 5) {
            return { delay: 3000, interval: 7000 };
        }

        if (fix >= 3) {
            return { delay: 3000, interval: 3000 };
        }

        return { delay: 3000, interval: 1000 };
    },

    findMove: function () {
        if (!Merge2.current || !Merge2.current.isGameMode()) {
            return;
        }

        const config = this.chooseConfig();
        if (!config) {
            return;
        }

        const sceneComponent = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent);
        if (!sceneComponent) {
            return;
        }

        const rows = Merge2.current.customers.listCanCook().map((customer) => customer.onGetView()).filter(Boolean);
        const row = rows.find((row) => sceneComponent.ordersTableView.isVisibleNode(row));
        const target = row && ComponentMap.getByName(row, "CustomerRecipeIconController").getTapTarget();

        if (target) {
            return {
                type: OrderHintLogic.type,
                delay: config.delay,
                interval: config.interval,
                target
            };
        }
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(OrderHintLogic);